import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto px-4 py-10 text-sm text-gray-700 space-y-4">

        {/* 정책 링크 */}
        <div className="flex flex-wrap gap-x-4 gap-y-2 font-semibold text-gray-800">
          <Link to="/policy/privacy" className="hover:underline">
            개인정보처리방침
          </Link>
          <Link to="/policy/refund" className="hover:underline">
            환불/취소 정책
          </Link>
        </div>

        {/* 사업자 정보 (필수) */}
        <div className="text-xs text-gray-600 leading-6">
          <div>상호명: 반딧불캔들</div>
          <div>대표자: 선성태</div>
          <div>사업자등록번호: 771-74-00632</div>
          {/*<div>통신판매업신고번호: 제2026-전남-0000호</div> */}
          <div>주소: 전라남도 화순군 도곡면 지강로 484, 2층</div>
          <div>전화: 010-9601-4161</div>
          <div>이메일: firefly4161@gmail.com</div>
        </div>

        <div className="text-xs text-gray-400 pt-4 border-t border-gray-100">
          © {new Date().getFullYear()} 반딧불캔들. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
